import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import logo from "../images/logo.svg";
import "../css/stylenew.css";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      <Navbar variant="dark" className="navbarStyle">
        <a className="navbar-brand" href="/">
          <div className="ikealogohantera">
            <div className="logoContainer">
              <img src={logo} id="icon" alt="Logo" />
              <span className="logoText">Hantera</span>
            </div>
          </div>
        </a>
        <div className="collapse navbar-collapse justify-content-end">
          {isAuthenticated ? <SignOutButton /> : <SignInButton />}
        </div>
      </Navbar>
      <br />
      <br />
      {props.children}
    </>
  );
};